import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef, signal } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Pos } from '../volkswagen.types';

@Component({
  selector: 'app-xml-pos-slp',
  imports: [CommonModule],

  standalone: true,
  template: `
    @if (type() === 'anmerkung') {
      <br />
      <br />
      @if (displayText()) {
        <span>{{ displayText() }}</span>
      }
    } @else if (type() === 'bauteil') {
      <li class="my-2">
        @if (displayText()) {
          <div>{{ displayText() }}</div>
        }

        <ng-template #childrenContainer></ng-template>
      </li>
    } @else {
      <li class="my-2">
        @if (displayText()) {
          <div>{{ displayText() }}</div>
        }
        <ng-template #childrenContainer></ng-template>
      </li>
    }

    <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
  `,
})
export class PosComponent extends XMLElementBaseComponent<Pos> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  displayText = signal<string>('');
  type = signal<string>('');

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  ngAfterViewInit() {
    if (this.data?.children) {
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(this.data.children, this.childrenContainer);
    }

    const data = this.data as never as any;
    this.displayText.set(data?.text);
    this.type.set(data?.typ);
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
